import { useMemo, VFC } from 'react';

import ReactSelect from 'dashboard/components/ReactSelect';
import ParamLabel from 'dashboard/components/WorkflowControlPanel/ParamLabel';
import useWorkflowError from 'dashboard/components/WorkflowControlPanel/useWorkflowError';
import { filterUsableObjects, UsableObjectConfig } from 'dashboard/lib/workflows';
import { WorkflowError, WorkflowFieldObjectKey } from 'dashboard/models/workflow';
import { WorkflowActionLabelObjectV1 } from 'dashboard/models/workflow-version';
import Spacer from 'design-system/components/Spacer';
import { Paragraph } from 'design-system/components/Text';

interface ParamsLabelObjectV1Props {
  editable: boolean;
  errors: WorkflowError[];
  params: WorkflowActionLabelObjectV1['params'];
  usableObjects: UsableObjectConfig[];
  updateActionParams: (params: WorkflowActionLabelObjectV1['params']) => void;
}

const ParamsLabelObjectV1: VFC<ParamsLabelObjectV1Props> = ({
  editable,
  errors,
  params,
  usableObjects,
  updateActionParams,
}) => {
  const possibleObjects = useMemo(() => {
    return filterUsableObjects({
      usableObjects,
      options: {
        permittedObjects: [WorkflowFieldObjectKey.Transaction],
        excludeNonPersonaObjects: true,
      },
    });
  }, [usableObjects]);
  const selectObject = (value: string) => {
    updateActionParams({
      ...params,
      object: value,
    });
  };

  const { hasErrorFor, renderErrorMessageFor } =
    useWorkflowError<keyof WorkflowActionLabelObjectV1['params']>(errors);

  return (
    <>
      <Spacer height={2} />
      <ParamLabel labelText='Object' htmlFor='params-label-object__object-input' />
      <Paragraph>
        Use a machine learning model developed by Persona to intelligently label data.
      </Paragraph>
      <Spacer height={1} />
      <ReactSelect
        value={params['object']}
        options={possibleObjects}
        onChange={selectObject}
        id='params-label-object__object'
        disabled={!editable}
        hasError={hasErrorFor('object')}
      />
      {renderErrorMessageFor('object')}
    </>
  );
};

export default ParamsLabelObjectV1;
